<template>
    <v-row>
        <input ref="fileInput" class="d-none" type="file" :multiple="multiple" @change="onFileChange"
               :accept="mimeTypes"/>
        <v-col cols="12" v-if="label" class="body-light label-color">
            {{ label }}
        </v-col>
        <v-col cols="12" v-if="isImage">
            <v-sheet v-if="!previewImg" v-ripple class="container-img pointer" @click.stop="pickFile">
                <v-img class="mx-auto" :src="require('@/assets/icons/upload.png')" width="100" eager/>
                <div class="headline-heavy text-center my-4">
                    Cargar Imagen
                </div>
                <div class="body-light grey-color text-center">
                    Puedes usar archivos PNG o JPG
                </div>
            </v-sheet>
            <v-sheet v-else class="container-img with-img" :style="`background-image: url(${previewImg})`">
                <v-btn @click.stop="onDeleteFile" color="error" icon class="button-img">
                    <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
            </v-sheet>
        </v-col>
        <v-col cols="12" v-else-if="isExcel">
            <v-sheet v-ripple class="container-img pointer" @click.stop="pickFile">
                <template v-if="!loading">
                    <v-img class="mx-auto" :src="require('@/assets/icons/upload.png')" width="100" eager/>
                    <div class="headline-heavy text-center my-4">
                        Cargar Excel
                    </div>
                    <div class="body-light grey-color text-center">
                        Actualiza el archivo maestro de examenes
                    </div>
                </template>
                <template v-else>
                    <loading-spinner no-margin-top/>
                </template>
            </v-sheet>
        </v-col>
        <v-col cols="12" v-else>
            <v-btn color="secondary" @click="pickFile" class="normal-btn" depressed>
                <v-icon class="mr-2">mdi-tray-arrow-up</v-icon>
                Cargar video
            </v-btn>
        </v-col>
        <v-col cols="12" v-if="details">
            <VMessages :value="errorBucket" color="error"/>
        </v-col>
    </v-row>
</template>

<script>
import {VInput} from "vuetify/lib/components";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    name: "KimsaUploadFile",
    components: {LoadingSpinner},
    extends: VInput,
    props: {
        relativePath: {
            type: String,
            default: 'files'
        },
        mimeTypes: {
            type: String,
            default: '*'
        },
        limitSize: {
            type: [String, Number],
            default: null,
        },
        previewImg: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        isImage: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isExcel: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            file: null,
            megabyte: 1048576,
        }
    },
    methods: {
        reset() {
            const vm = this
            vm.file = null
            vm.$refs.fileInput.value = null
        },
        pickFile() {
            const vm = this
            if (vm.previewImg) return;
            vm.$refs.fileInput.click()
        },
        onFileChange(evt) {
            const vm = this
            const file = vm.multiple ?
                evt.target.files :
                evt.target.files[0]
            if (!file || file.length === 0) return;

            let limitSize = (vm.limitSize * vm.megabyte)
            if (vm.limitSize && (vm.multiple && !!file.find(f => f.size > limitSize) || file.size > limitSize))
                return vm.toast(`Tamaño maximo es de ${vm.limitSize}mb`, 'error')

            if (vm.isExcel) return vm.$emit('change', file)

            if (vm.multiple) {
                let array = Array.from(vm.file || [])
                if (array.length > 0) {
                    array.push(file)
                    vm.file = array
                } else vm.file = file
                vm.$emit('change', vm.listFileImgName())
            } else {
                vm.file = file
                let imgURL = URL.createObjectURL(vm.file);
                vm.$emit('change', {img: imgURL, file: vm.file})
            }
        },
        listFileImgName() {
            const vm = this
            let files = []
            let array = Array.from(vm.file)
            array.forEach(f => {
                files.push({
                    img: URL.createObjectURL(f[0] || f),
                    file: f[0] || f
                })
            })
            return files
        },
        onDeleteFile() {
            const vm = this
            vm.file = null
            vm.$emit('change', null)
            vm.$emit('delete')
        },
        onDeleteFileByIndex(index) {
            const vm = this
            const array = Array.from(vm.file || [])
            array.splice(index, 1)
            vm.file = array
            vm.$emit('change', vm.listFileImgName())
        },
    },
}
</script>

<style scoped>

.container-img {
    background-color: #F9F9F9;
    border: 1px solid #C9CDD9;
    box-sizing: border-box;
    border-radius: 8px;
    color: #273866;
    padding-top: 32px;
    padding-bottom: 32px;
    height: 270px;
}

.with-img {
    position: relative !important;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.button-img {
    position: absolute;
    top: 3%;
    right: 3%;
}

</style>